// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instructions-tab {
  padding: 0.5rem 0;
}

.instructions-tab-intro {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.9rem;
  margin: 0 0 1rem;
  border-radius: 999px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.4;
}

.instructions-tab-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.75rem;
}

.instructions-tab-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.instructions-tab-card:hover {
  border-color: var(--accent-primary);
  background: var(--bg-tertiary);
  color: var(--accent-primary);
}

.instructions-tab-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.instructions-tab-title {
  font-size: 0.9rem;
  line-height: 1.3;
}

/* Mobile: mindestens 2 Spalten, kompakter und kleinere Schrift */
@media (max-width: 680px) {
  .instructions-tab-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .instructions-tab-card {
    padding: 0.5rem 0.6rem;
    gap: 0.5rem;
    min-height: 0;
  }

  .instructions-tab-icon {
    font-size: 1.15rem;
  }

  .instructions-tab-title {
    font-size: 0.75rem;
    line-height: 1.25;
  }

  .instructions-tab-intro {
    font-size: 0.8rem;
    padding: 0.3rem 0.7rem;
    margin-bottom: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InstructionsTab/InstructionsTab.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE;IACE,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":[".instructions-tab {\n  padding: 0.5rem 0;\n}\n\n.instructions-tab-intro {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.9rem;\n  margin: 0 0 1rem;\n  border-radius: 999px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.instructions-tab-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.75rem;\n}\n\n.instructions-tab-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 10px;\n  color: var(--text-primary);\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.instructions-tab-card:hover {\n  border-color: var(--accent-primary);\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n}\n\n.instructions-tab-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.instructions-tab-title {\n  font-size: 0.9rem;\n  line-height: 1.3;\n}\n\n/* Mobile: mindestens 2 Spalten, kompakter und kleinere Schrift */\n@media (max-width: 680px) {\n  .instructions-tab-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.5rem;\n  }\n\n  .instructions-tab-card {\n    padding: 0.5rem 0.6rem;\n    gap: 0.5rem;\n    min-height: 0;\n  }\n\n  .instructions-tab-icon {\n    font-size: 1.15rem;\n  }\n\n  .instructions-tab-title {\n    font-size: 0.75rem;\n    line-height: 1.25;\n  }\n\n  .instructions-tab-intro {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.7rem;\n    margin-bottom: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
